

/**
 * Mixin per i dialog
 *
 * @mixin
 *
 * @property {boolean} value - Stato del dialog
 *
 * @var {boolean} dialog - Stato del dialog
 *
 * @method onCancel - Chiude il dialog senza memorizzare i dati
 * @method onSave - Richiede la memorizzazione dei dati e chiude il dialog
 *
 * @emits cancel - Il dialog è stato chiuso senza la richiesta di memorizzare i dati
 * @emits save - Il dialog è stato chiuso con la richiesta di memorizzare i dati
 */

import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';

@Component
export default class DialogMixin extends Vue {
  @Prop(Boolean) readonly value!: boolean;

  dialog = false

  @Watch('value')
  onValueChange(val: boolean) {
    this.dialog = val;
  }

  @Watch('dialog')
  onDialogChange(val: boolean) {
    if (this.value !== val) {
      this.$emit('input', val);
    }
  }

  // Chiude il dialog senza memorizzare i dati
  onCancel() {
    console.log(`${this.constructor.name}: onCancel()`); // eslint-disable-line no-console

    this.dialog = false;

    this.$emit('cancel');
  }

  // Richiede la memorizzazione dei dati e chiude il dialog
  async onSave(close = true) {
    console.log(`${this.constructor.name}: onSave()`); // eslint-disable-line no-console

    // Chiude il dialog se richiesto (default)
    if (close) this.dialog = false;

    this.$emit('save');
  }
}
